module.exports = __webpack_public_path__ + "img/lexus.5a82d504.jpg";